/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Divider, Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';

import { DamsServices, IDam } from '../../services/api/dams/DamServices';
import { ToolsDetails } from '../../components/custom';
import { Loadin } from '../../components/shared';
import { LayoutBase } from '../../layouts';
import { useAuthContext } from '../../context';
import { ConfirmationDialog } from '../../components/shared/VConfirmationDialog';
import { CustomAlert } from '../../components/shared/VAlert';
import { UploadFile } from '@mui/icons-material';
import ReactInputMask from 'react-input-mask';
import { helpers } from '../../services/helpers/helpers';


export const DetailsDam: React.FC = () => {
    const url = useParams();

    const navigate = useNavigate();
    const { userData } = useAuthContext();
    const [isNew, setIsNew] = useState(true);
    const [isLoading, setIsLonding] = useState(false);
    const [isDialogOpen, setDialogOpen] = useState(false);
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });
    const [imageSrc, setImageSrc] = useState<string | undefined>(undefined);
    const theme = useTheme();
    const [sendClick, setSendClick] = useState<boolean>(false);

    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    const companyUuid = userData.id_empresa;

    const [data, setData] = useState<IDam>({
        id_empresa: companyUuid ? companyUuid : '',
        nome: '',
        utm_ns: undefined,
        utm_ew: undefined,
        utm_zone: undefined,
        id_empreendimento: '',
        status: true,
        producao_anual: null,
        funcionarios: null,
        descricao_acesso: null,
        elevacao: null,
        timezone: null,
        utm_zone_location: null,
        total_area: null,
        mineral: null,
        direito_mineracao: null,
        // foto_barragem: null,
        proposito: null,
        status_operacional: null,
        anm: null,
        inicio_operacao: null,
        fim_operacao: null,
        agencia_reguladora: null,
        elevacao_crista: null,
        comprimento_crista: null,
        altura_maxima_crista: null,
        inclinacao_talude_montante: null,
        inclinacao_talude_jusante: null,
        berma: null,
        volume_estrutura: null,
        area_estrutura: null,
        volume_macico: null,
        composicao_macico: null,
        sistema_dranagem: null,
        extravasor: null,
        impermeablizacao: null,
        fundacao: null,
        curso_dagua_barrado: null,
        vazao_residual_curso_dagua: null,
        processo_beneficiamento: null,
        produtos_quimicos: null,
        rejeito_cianeto: null,
        mineral_presente_rejeito: null,
        teor_mineral_rejeito: null,
        teor_outros_mineral_rejeito: null,
        densidade_rejeito: null,
        geracao_rejeito: null,
        teor_solidos_polpa: null,
        projecao: null,
        latitude: '',
        longitude: '',
        uuid: '',
        insert_date: null,
        update_date: null,
        user_update: null,
        inspection_sheet_responsible: null,
        cota_crista: null,
        historico_construtivo: null,
        metodo_construtivo: null,
        qtd_alteamentos_previstos: null,
        qtd_alteamentos_executados: null,
        legenda_faixa_verde: null,
        legenda_faixa_amarela: null,
        legenda_faixa_laranja: null,
        legenda_faixa_vermelha: null,
    });

    const [validations, setValidations] = useState<{ [key: string]: boolean }>({
        nome: false,
        utm_zone: false,
        utm_zone_location: false,
        utm_ns: false,
        utm_ew: false,
    });

    const [img, setImg] = useState<string>();


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;

        let parsedValue: string | number | boolean = value;

        if (name === 'utm_ew' || name === 'utm_ns') {
            const cleanValue = value.replace(/[^\d.]/g, '');
            parsedValue = cleanValue === '' ? 0 : parseFloat(cleanValue);
        } else {
            switch (type) {
                case 'number':
                    parsedValue = parseFloat(value) || 0;
                    break;
                case 'checkbox':
                    parsedValue = checked;
                    break;
                default:
                    parsedValue = value;
            }
        }

        const updatedData = { ...data, [name]: parsedValue };
        setData(updatedData);
    };

    async function validateData(data: IDam) {
        const newValidations = {
            nome: !data.nome,
            utm_ns: !data.utm_ns,
            utm_ew: !data.utm_ew,
            utm_zone_location: !data.utm_zone_location,
            utm_zone: !data.utm_zone,
        };

        setValidations(newValidations);

        const isAnyInvalid = Object.values(newValidations).some(value => value);
        return !isAnyInvalid;
    }

    useEffect(() => {
        fecthData();
    }, [url]);

    useEffect(() => {
        if (data.image instanceof File) {
            const objectUrl = URL.createObjectURL(data.image);
            setImageSrc(objectUrl);
            return () => URL.revokeObjectURL(objectUrl);
        } else if (typeof data.image === 'string') {
            if (data.image.startsWith('/9j/') || data.image.startsWith('iVBORw0KGgoAAAANSUhEUg')) {
                setImageSrc(`data:image/jpeg;base64,${data.image}`);
            } else {
                setImageSrc(data.image);
            }
        } else {
            setImageSrc(undefined);
        }
    }, [data.image]);

    const fecthData = () => {
        setIsLonding(true);
        if (url.uuid !== 'novo') {
            setIsNew(false);
            DamsServices.getById(url.uuid ? url.uuid : '')
                .then((response) => {
                    if (response instanceof Error) {
                        alert(response.message);
                    } else {
                        const { empreendimento, empresa, instrumentos, kpis, ...resto } = response;
                        setData(resto);
                        if (data.status == false) {
                            navigate('/company_dam');
                        } else {
                            setIsLonding(false);
                        }
                    }
                });
        }
        setIsLonding(false);
    };

    async function handleSave() {
        setAlertInfo({ open: false, message: '', severity: 'warning' });
        setSendClick(true);
        if (url.uuid !== 'novo') {
            if (data !== undefined) {
                const isValid = await validateData(data);
                if (isValid) {
                    if (!(data.image instanceof File) && data.image) {
                        data.image = helpers.base64ToImg(data.image);
                    }
                    const response = await DamsServices.upgrade(url.uuid ? url.uuid : '', data);

                    if (response instanceof Error) {
                        setAlertInfo({ open: true, message: 'Não foi possível atualizar a barragem! ' + response.message, severity: 'error' });
                        setSendClick(false);
                    }
                    else {
                        setAlertInfo({ open: true, message: 'Barragem atualizada!', severity: 'success' });
                        setSendClick(false);
                    }
                } else {
                    setSendClick(false);
                }
            } else {
                setSendClick(false);
            }
        } else {
            if (data !== undefined) {
                setValidations(prevState => ({
                    ...prevState,
                    id_empresa: true
                }));

                const isValid = await validateData(data);
                if (isValid) {
                    delete data.uuid;
                    const response = await DamsServices.create(url.org ? url.org : '', data);
                    if (response instanceof Error) {
                        setAlertInfo({ open: true, message: 'Não foi possível salvar a barragem! ' + response.message, severity: 'error' });
                        setSendClick(false);
                    } else {
                        setAlertInfo({ open: true, message: 'Barragem salva!', severity: 'success' });
                        setSendClick(false);
                        setTimeout(() => {
                            navigate(-1);
                        }, 2000);
                    }
                } else {
                    setSendClick(false);
                }
            }
        }
    }

    async function handleDelete(uuid: string | undefined) {
        if (uuid !== 'novo' && uuid !== undefined) {
            const response = await DamsServices.delet(uuid);
            if (response instanceof Error) {
                setAlertInfo({ open: true, message: 'Não foi possível excluir a barragem! ' + response.message, severity: 'error' });
                setTimeout(() => {
                    navigate('/company_dam');
                }, 2000);
            }
            else {
                setAlertInfo({ open: true, message: 'Barragem excluída!', severity: 'success' });
                setTimeout(() => {
                    navigate('/company_dam');
                }, 2000);
            }
        }
    }

    function handleDeleteClick(uuid: string) {
        if (uuid && uuid !== 'novo') {
            setDialogOpen(true);
        }
    }

    function handleNew() {
        navigate('/company_dam/detalhes/novo');
        window.location.reload();
    }



    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {

        if (e.target.files && e.target.files.length > 0) {
            const selectedFile = e.target.files[0];
            setData(prevData => ({
                ...prevData,
                image: selectedFile,
            }));

            const img = await convertFileToBase64(selectedFile);
            setImg(img);
        }
    };

    async function convertFileToBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64String = (reader.result as string).split(',')[1];
                resolve(base64String);
            };

            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    }

    if (isLoading == true) {
        return (
            <Loadin />
        );
    } else {
        return (
            <LayoutBase title={isNew ? 'Nova Barragem' : data.nome}
                tollBar={
                    <ToolsDetails
                        showSaveButton={userData.permissoes.includes('add')}
                        showDeletButton={userData.permissoes.includes('remove')}
                        onClickNew={() => handleNew()}
                        onClickSave={() => handleSave()}
                        onClickDelet={() => handleDeleteClick(url.uuid ? url.uuid : '')}
                        disableSave={sendClick}
                    />
                }
            >

                <Box width={'100%'} display={'flex'}>
                    <Grid container direction={'column'} padding={2} spacing={2}>
                        <Grid container item direction={'row'} spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant='h5'>Informações Gerais</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }} label='Nome'
                                    name='nome'
                                    fullWidth value={data.nome || ''}
                                    onChange={handleChange}
                                    error={validations.nome}
                                    required
                                />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Propósito'
                                    name='proposito'
                                    fullWidth value={data.proposito || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Processo de Beneficiamento'
                                    name='processo_beneficiamento'
                                    fullWidth value={data.processo_beneficiamento || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Status Operacional'
                                    name='status_operacional'
                                    fullWidth value={data.status_operacional || ''}
                                    onChange={handleChange} />
                            </Grid>
                            {/* <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }} label='Foto' name='foto_barragem' fullWidth value={data.foto_barragem || ''} onChange={handleChange} />
                            </Grid> */}
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Início de Operação'
                                    name='inicio_operacao'
                                    fullWidth value={data.inicio_operacao || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Fim de Operação'
                                    name='fim_operacao'
                                    fullWidth value={data.fim_operacao || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Agência Reguladora'
                                    name='agencia_reguladora'
                                    fullWidth value={data.agencia_reguladora || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Processo minerário associado (ANM)'
                                    name='anm'
                                    fullWidth
                                    value={data.anm || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Número de funcionarios'
                                    name='funcionarios'
                                    fullWidth value={data.funcionarios || ''}
                                    onChange={handleChange}
                                    type='number' />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant='h5'>Características Técnicas</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Altura Máxima da Crista'
                                    name='altura_maxima_crista'
                                    fullWidth
                                    value={data.altura_maxima_crista || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Comprimento da Crista'
                                    name='comprimento_crista'
                                    fullWidth
                                    value={data.comprimento_crista || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Inclinação do Talude Montante'
                                    name='inclinacao_talude_montante'
                                    fullWidth
                                    value={data.inclinacao_talude_montante || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Inclinação do Talude Jusante'
                                    name='inclinacao_talude_jusante'
                                    fullWidth
                                    value={data.inclinacao_talude_jusante || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Mineral'
                                    name='mineral'
                                    fullWidth
                                    value={data.mineral || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Direito de Mineração'
                                    name='direito_mineracao'
                                    fullWidth
                                    value={data.direito_mineracao || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Berma'
                                    name='berma'
                                    fullWidth
                                    value={data.berma || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Volume da Estrutura'
                                    name='volume_estrutura'
                                    fullWidth
                                    value={data.volume_estrutura || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Área da Estrutura'
                                    name='area_estrutura'
                                    fullWidth
                                    value={data.area_estrutura || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Volume do Maciço'
                                    name='volume_macico'
                                    fullWidth
                                    value={data.volume_macico || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Composição do Maciço'
                                    name='composicao_macico'
                                    fullWidth
                                    value={data.composicao_macico || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Sistema de Drenagem'
                                    name='sistema_dranagem'
                                    fullWidth
                                    value={data.sistema_dranagem || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Extravasor'
                                    name='extravasor'
                                    fullWidth
                                    value={data.extravasor || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Impermeabilização'
                                    name='impermeablizacao'
                                    fullWidth
                                    value={data.impermeablizacao || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Fundação'
                                    name='fundacao'
                                    fullWidth
                                    value={data.fundacao || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Curso dÁgua Barrado'
                                    name='curso_dagua_barrado'
                                    fullWidth
                                    value={data.curso_dagua_barrado || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Vazão Residual do Curso dÁgua'
                                    name='vazao_residual_curso_dagua'
                                    fullWidth
                                    value={data.vazao_residual_curso_dagua || ''}
                                    onChange={handleChange} />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant='h5'>Características Operacionais</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Produtos Químicos'
                                    name='produtos_quimicos'
                                    fullWidth
                                    value={data.produtos_quimicos || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Rejeito de Cianeto'
                                    name='rejeito_cianeto'
                                    fullWidth
                                    value={data.rejeito_cianeto || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Mineral Presente no Rejeito'
                                    name='mineral_presente_rejeito' fullWidth value={data.mineral_presente_rejeito || ''} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Teor Mineral do Rejeito'
                                    name='teor_mineral_rejeito'
                                    fullWidth
                                    value={data.teor_mineral_rejeito || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Teor de Outros Minerais no Rejeito'
                                    name='teor_outros_mineral_rejeito'
                                    fullWidth
                                    value={data.teor_outros_mineral_rejeito || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Densidade do Rejeito'
                                    name='densidade_rejeito'
                                    fullWidth
                                    value={data.densidade_rejeito || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Geração do Rejeito'
                                    name='geracao_rejeito'
                                    fullWidth
                                    value={data.geracao_rejeito || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Teor de Sólidos na Polpa'
                                    name='teor_solidos_polpa'
                                    fullWidth
                                    value={data.teor_solidos_polpa || ''}
                                    onChange={handleChange} />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant='h5'>Localização</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Zona de Fuso'
                                    name='utm_zone'
                                    fullWidth value={data.utm_zone || ''}
                                    onChange={handleChange}
                                    error={validations.utm_zone}
                                    required />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Fuso Local'
                                    name='utm_zone_location'
                                    fullWidth
                                    value={data.utm_zone_location || ''}
                                    onChange={handleChange}
                                    error={validations.utm_zone_location}
                                    required />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <ReactInputMask
                                    mask={'9999999.99'}
                                    onChange={handleChange}
                                    value={data.utm_ns}
                                    name='utm_ns'
                                >
                                    {() =>
                                        <TextField InputLabelProps={{ shrink: true }}
                                            label='UTM NS'
                                            fullWidth
                                            name='utm_ns'
                                            required
                                        />
                                    }
                                </ReactInputMask>
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <ReactInputMask
                                    mask={'999999.99'}
                                    onChange={handleChange}
                                    value={data.utm_ew}
                                    name='utm_ew'
                                >
                                    {() =>
                                        <TextField InputLabelProps={{ shrink: true }}
                                            label='UTM EW'
                                            fullWidth
                                            name='utm_ew'
                                            required
                                        />
                                    }
                                </ReactInputMask>

                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant='h5'>Alteamentos/Alteração de cota Crista</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Cota da Crista'
                                    name='cota_crista'
                                    fullWidth
                                    value={data.cota_crista || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Histórico Construtivo'
                                    name='historico_construtivo'
                                    fullWidth
                                    value={data.historico_construtivo || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Método Construtivo'
                                    name='metodo_construtivo'
                                    fullWidth
                                    value={data.metodo_construtivo || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Quantidade de Alteamentos Previstos'
                                    name='qtd_alteamentos_previstos'
                                    fullWidth
                                    value={data.qtd_alteamentos_previstos || ''}
                                    onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }}
                                    label='Quantidade de Alteamentos Executados'
                                    name='qtd_alteamentos_executados'
                                    fullWidth
                                    value={data.qtd_alteamentos_executados || ''}
                                    onChange={handleChange} />
                            </Grid>

                            {/* <Grid item xs={12}>
                                <Typography variant='h5'>Carta de Risco</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }} label='Legenda Faixa Verde' name='legenda_faixa_verde' fullWidth value={data.legenda_faixa_verde || ''} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }} label='Legenda Faixa Amarela' name='legenda_faixa_amarela' fullWidth value={data.legenda_faixa_amarela || ''} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }} label='Legenda Faixa Laranja' name='legenda_faixa_laranja' fullWidth value={data.legenda_faixa_laranja || ''} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField InputLabelProps={{ shrink: true }} label='Legenda Faixa Vermelha' name='legenda_faixa_vermelha' fullWidth value={data.legenda_faixa_vermelha || ''} onChange={handleChange} />
                            </Grid> */}
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>
                                <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
                                    <Typography>Imagem da barragem</Typography>
                                    <Button component="label" role={undefined} variant="contained" tabIndex={-1} startIcon={<UploadFile />} htmlFor="file-input">
                                        Upload file
                                        <input id="file-input" type="file" accept='.jpg' onChange={handleFileChange} hidden />
                                    </Button>
                                    <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
                                        Apenas arquivos .jpg são permitidos.
                                    </Typography>c
                                </Box>
                            </Grid>
                            {data.image ?
                                <Grid item xs={12} display={'flex'} justifyContent={'center'} alignContent={'center'} flexDirection={'column'}>
                                    <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
                                        <Typography textAlign={'center'}>Imagem</Typography>
                                        <Box
                                            sx={{
                                                border: '2px solid grey',
                                                flex: 1,
                                                borderRadius: 2,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            <img
                                                src={imageSrc}
                                                alt="Logo"
                                                style={{
                                                    width: '100%',
                                                    height: '50',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                </Grid>
                                : null
                            }
                        </Grid>
                    </Grid>
                    {alertInfo.open &&
                        <CustomAlert
                            message={alertInfo.message}
                            severity={alertInfo.severity}
                        />
                    }
                    <ConfirmationDialog
                        isOpen={isDialogOpen}
                        onClose={() => setDialogOpen(false)}
                        onConfirm={() => handleDelete(url.uuid)}
                        title="Confirmar Exclusão"
                        message="Tem certeza de que deseja excluir esta barragem?"
                    />
                </Box>
            </LayoutBase>
        );
    }
};